module.exports = __webpack_public_path__ + "static/media/hero.65f80f68.jpg";